import { Flex } from "antd";
import { SvgIcons } from "Icon/SvgIcons";
import React, { useEffect, useRef, useState } from "react";

// Define types
interface Company {
  name: string;
}

interface User {
  first_name: string;
  last_name: string;
  company: Company;
}

interface FeedbackItem {
  test: string;
}

interface Note {
  id: string | number;
  user: User;
  feedback: FeedbackItem[];
}

interface FeedbackProps {
  candidateNotes: Note[];
}

const Feedback: React.FC<FeedbackProps> = ({ candidateNotes }) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      setIsOverflowing(el.scrollHeight > 181);
    }
  }, [candidateNotes]);

  return (
    <div className="bg-bg-secondary mt-1 my-1 p-3 ">
      <div
        ref={contentRef}
        className={`flex flex-col gap-2 relative transition-all overflow-hidden ease-in-out ${
          expanded ? "max-h-[1000px]" : "max-h-[150px]"
        }`}
      >
        {candidateNotes &&
          candidateNotes.map((note) => {
            return note?.feedback ? (
              <Flex gap={6} vertical key={note.id}>
                <Flex gap={4} align="center">
                  <span className="text-sm text-text-tertiary font-semibold">
                    {note?.user?.company?.name}
                  </span>
                  <span className="bg-text-heading h-3 w-0.5"></span>
                  <span className="text-sm text-text-heading font-semibold">
                    {note?.user?.first_name} {note?.user?.last_name}
                  </span>
                </Flex>

                {note?.feedback?.map((feedback: any, idx) => (
                  <div key={idx}>
                    <p className="text-sm text-text-secondary font-normal font-semibold" key={idx}>
                      {feedback.question}
                    </p>
                    <p className="text-sm text-text-secondary font-normal" key={idx + "a"}>
                      {feedback.answer}
                    </p>
                  </div>
                ))}
              </Flex>
            ) : (
              ""
            );
          })}

        {!expanded && isOverflowing && (
          <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-bg-secondary to-transparent pointer-events-none" />
        )}
      </div>

      {isOverflowing && (
        <button
          onClick={() => setExpanded((prev) => !prev)}
          className="flex py-[3px] pl-[6px] pr-2 
                    justify-center items-center gap-[3px] text-xs font-medium
                     text-text-secondary bg-[#ECECED] border border-main-border rounded-md mx-auto -mb-7"
        >
          <span className={`transition-all ${expanded ? "rotate-180" : ""}`}>
            {SvgIcons.blackDownArrow}
          </span>
          {expanded ? "Show less" : "Read more"}
        </button>
      )}
    </div>
  );
};

export default Feedback;
